<script setup>
import AppStaffStatus from "@/views/staff/AppStaffStatus.vue"

const props = defineProps({
  staff: {
    type: Object,
    default: null,
  },
  showInfo: {
    type: Boolean,
    default: true,
  },
  avatarSize: {
    type: [String, Number],
    default: 26,
  },
  showAvatar: true,
  showStatus: {
    type: Boolean,
    default: false,
  },
})
</script>


<template>
  <div class="d-flex align-center">
    <VAvatar
      v-if="showAvatar"
      :size="avatarSize"
      color="primary"
      variant="tonal"
    >
      <span style="font-size: 10px">{{ avatarText(staff?.name) }}</span>
    </VAvatar>
    <div
      v-if="showInfo"
      class="d-flex flex-column ms-1"
    >
      <div>
        {{ staff?.name }}
      </div>
      <span
        style="font-size: 12px; margin-top: -5px;"
        class="text-sm text-medium-emphasis"
      >{{ staff?.code }}</span>
      <AppStaffStatus
        v-if="showStatus"
        :status="staff.status"
      />
    </div>
  </div>
</template>
